import { render, staticRenderFns } from "./ObservacionInfo.vue?vue&type=template&id=73034afd&"
import script from "./ObservacionInfo.vue?vue&type=script&lang=js&"
export * from "./ObservacionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports